export const shippingNames = [
  'Ground Shipping',
  'Priority Shipping',
  'Priority Express',
];
